// extracted by mini-css-extract-plugin
export default {"wrapper":"ingredient-details-page_wrapper__eLzZb","container":"ingredient-details-page_container__XJ8WP"};